<template>
    <z-basePage :title="'新建BU'" :pop="true">

        <div class="main" v-form="'back-createBu'">

            <div class="left">
                <!-- 基本信息 -->
                <div class="base-item">
                    <div class="small-title">基本信息</div>
                    <div class="back-item">
                        <div class="back-title">BU名称</div>
                        <div class="back-wrap">
                            <el-input class="top-choose z-mid" rule="noVal" v-tar="sub.bu_name" v-model="sub.bu_name" placeholder="请输入BU名称">
                            </el-input>
                        </div>
                    </div>
                    <div class="back-item">
                        <div class="back-title">BU合伙人</div>
                        <div class="back-wrap">
                            <el-select class="top-choose z-mid" v-tar="sub.leader_id" v-model="sub.leader_id" filterable clearable placeholder="请选择">
                                <el-option
                                v-for="item in person_list"
                                :key="item.id"
                                :label="item.real_name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="back-item area">
                        <div class="back-title">BU职责</div>
                        <div class="back-wrap">
                            <textarea rule="reason describe_limit" v-arg="'BU职责描述'" v-tar="sub.describe" v-model="sub.describe" placeholder="请描述BU职责"></textarea>
                        </div>
                    </div>
                    <!-- <input v-tar="sub.manage_ids" v-model="sub.manage_ids" v-show="false">
                    <input v-tar="sub.release_ids" v-model="sub.release_ids" v-show="false"> -->
                </div>

                <!-- 经营范围 -->
                <div class="base-item" >
                    <div class="small-title">
                        经营范围
                        <el-checkbox v-model="check_manage" @change="manageAll"></el-checkbox>
                    </div>
                    <el-checkbox-group v-model="sub.manage_ids" v-tar="manage_strIds" @change="manageCheck">
                        <el-checkbox v-for="item in tpl_list" :key="item.id" :label="item.id">{{ item.tpl_name }}</el-checkbox>
                    </el-checkbox-group>
                </div>

                <!-- 发布范围 -->
                <div class="base-item">
                    <div class="small-title">
                        发布范围
                        <el-checkbox v-model="check_release" @change="releaseAll"></el-checkbox>
                    </div>
                    <el-checkbox-group v-model="sub.release_ids" v-tar="release_strIds" @change="releaseCheck">
                        <el-checkbox v-for="item in tpl_list" :key="item.id" :label="item.id">{{ item.tpl_name }}</el-checkbox>
                    </el-checkbox-group>
                </div>


            </div>

            <div class="right" v-tar="user_strIds">
                <div class="small-title">BU成员选择</div>
                <member :leaderId="sub.leader_id" :list="person_list" :cancel="cancel_flag" @change="getMemberIds" @cancel="cancel_flag = false"></member>
            </div>
        </div>

        <div class="btns">
            <div class="back-btn blue" @click="save">创建</div>
            <div class="back-btn" :class="{disabled:!now_form.changeFlag}" @click="cancel">取消</div>
        </div>
        
    </z-basePage>
</template>

<script>
    import member from './add-member.vue'

    export default {
        components:{
            member,
        },
        data(){
            return {
                person_list:[],  //未分组人员列表
                tpl_list:[],  //任务类型 数组
                now_form:{},

                sub:{  //提交的
                    bu_name:"",
                    leader_id:"",
                    describe:"",
                    manage_ids:[],  //经营范围 ids
                    release_ids:[],  // 发布范围 ids  
                    user_ids:[],  //成员id 列表
                },

                check_manage:false,  //经营范围 全选
                check_release:false,  //发布范围 全选

                cancel_flag:false,  //取消判断
            }
        },
        computed:{
            all_tpl_ids(){   //全选tpl id  合集
                return this.tpl_list.map(item=>item.id);
            },
            release_strIds(){
                return this.sub.release_ids.sort().join(',');
            },
            manage_strIds(){
                return this.sub.manage_ids.sort().join(',');
            },
            user_strIds(){
                return this.sub.user_ids.sort().join(',');
            },

        },

        created(){
            this.fresh();
        },

        mounted(){
			this.now_form = this.$form.forms["back-createBu"];
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-createBu',path:to.path});
			next(res);
        },
        
        methods:{
            fresh(){
                let url =`api/admin/tpl/list`;
                this.$http.get(url).then(res=>{  //tpl 数组
                    if(res.status == 200){
                        this.tpl_list = res.res_data;
                    }
                });

                let url2 = `api/admin/candidate_bu/userlist`;
                this.$http.get(url2).then(res=>{  // 未分组人员 数组
                    if(res.status == 200){
                        this.person_list = res.res_data;
                    }
                });
            },
            // ***多选功能

            manageAll(event){   //经营范围  全选
                this.sub.manage_ids = event.target.checked?[...this.all_tpl_ids]:[];
            },
            releaseAll(event){   //发布范围  全选
                this.sub.release_ids = event.target.checked?[...this.all_tpl_ids]:[];
            },
            manageCheck(){  //经营范围 单选
                this.check_manage = this.sub.manage_ids.length === this.all_tpl_ids.length;
            },
            releaseCheck(){ //发布范围 单选
                this.check_release = this.sub.release_ids.length === this.all_tpl_ids.length;
            },

            // 选择BU成员
            getMemberIds(arr){
                this.sub.user_ids = arr;
            },

            // ***页面保存

            save(){  //保存
				let res = this.$form.check("back-createBu");
				if(!res){
					return;
				}
                this.$func.loading(true);
                let url = `api/admin/bu_employee/bu/add`;
                this.$http.post(url,{
                    bu_name:this.sub.bu_name,
                    bu_partner:this.sub.leader_id,
                    bu_description:this.sub.describe,
                    bu_sub_tpl:this.manage_strIds,
                    bu_pub_tpl:this.release_strIds,
                    bu_member:this.user_strIds,
                }).then(res=>{
                    if(res.status == 200){
                        this.$form.breakFlag = true;  //允许跳走
                        this.$router.push({
                            name:'back-person-assign',
                        });
                        this.successTip("创建成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                })
                
                // save
			},
			cancel(){  //取消
                this.sub = {  
                    bu_name:"",
                    leader_id:"",
                    describe:"",
                    manage_ids:[],  //经营范围 ids
                    release_ids:[],  // 发布范围 ids  
                    user_ids:[],  // 成员id 列表
                };
                this.check_manage = false;  //经营范围 全选
                this.check_release = false;  //发布范围 全选
                this.cancel_flag = true;
			},
        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";

    // 总体布局
    .main{
        overflow: hidden;
        .left,.right{
            float: left;
        }
        .left{
            width:530px;
            margin-right: 50px;
        }
        .right{
            width:380px;
        }


    }

    // 多选框
    .el-checkbox{
        margin:0;
        margin-right: 15px;
        margin-bottom: 10px;
    }
    
    .back-item{
        &:after{
            content:"";
            display: block;
            clear: both;
        }
        .back-title{
            float:left;
            width:70px;
        }
        .back-wrap{
            float:left;
        }

    }

    .btns{
        font-size:0;
        margin-top:40px;
        .back-btn{
            margin-right:15px;
        }
    }

    .small-title{
        font-size: 12px;
        font-weight: 600;
        padding-left:5px; 
        border-left:2px solid #a4e6f2;
        margin: 20px 0;
        .el-checkbox{
            margin:0;
        }
    }
</style>





// WEBPACK FOOTER //
// page-add-bu.vue?44256e74